import React, {useEffect} from "react";
import {useForm} from "react-hook-form";
import Input from "../../components/wrapperComponents/Input";
import * as Validation from "@utilities/validationRules";
import {CentroDiCostoRecord} from "@commons/mapping/CentroDiCostoRecord";
import {coalesce} from "../../core/editor";
import FormButtons from "../../components/FormButtons";

interface AziendaTabelleEditorProps {
    defaultValues: CentroDiCostoRecord,
    resource: CentroDiCostoRecord,
    onSubmit: (formData: CentroDiCostoRecord) => void,
    onCancel: () => void,
}

const AziendaTabelleEditor: React.FC<AziendaTabelleEditorProps> = ({defaultValues, resource, onSubmit, onCancel}) => {

    const currentValues: CentroDiCostoRecord = {
        ...defaultValues, ...resource,
        ...{
            id: resource ? coalesce(resource.id, defaultValues.id) : defaultValues.id,
            descrizione: resource ? coalesce(resource.descrizione, defaultValues.descrizione) : defaultValues.descrizione,
        }
    };

    // https://stackoverflow.com/questions/62242657/how-to-change-react-hook-form-defaultvalue-with-useeffect
    const {register, getValues, setValue, handleSubmit, reset, formState: {errors}} = useForm<CentroDiCostoRecord>();
    useEffect(() => {
        reset(currentValues);
    }, [resource]);

    function onHandleSubmit(newValues: CentroDiCostoRecord) {
        onSubmit({...newValues})
    }

    return <>

        <form onSubmit={handleSubmit(onHandleSubmit)}>
            <div className="flex flex-col sm:flex-row">

                <div className="max-sm:w-full w-4/12 mr-4">
                    <label htmlFor="first-name" className="block text-sm font-medium">
                        Codice tabella
                    </label>

                    <Input
                        type="text"
                        name="id"
                        register={register}
                        registerOptions={Validation.required}
                        errors={errors}
                        maxLength={6}
                    />
                </div>

                <div className="max-sm:w-full w-8/12">
                    <label htmlFor="last-name" className="block text-sm font-medium">
                        Descrizione
                    </label>

                    <Input
                        type="text"
                        name="descrizione"
                        register={register}
                        registerOptions={Validation.required}
                        errors={errors}
                        maxLength={30}
                    />
                </div>

            </div>

            <FormButtons onCancel={onCancel} resource={resource}/>

        </form>

    </>;
}
export default AziendaTabelleEditor;
